import React from 'react'
import { createRoot } from 'react-dom/client'
import FooterWholesaler from './FooterWholesaler.jsx'

class FooterWholesalerElement extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    const reactContainerId = 'footer-wholesaler-react-app'
    const reactContainer = document.createElement('div')

    reactContainer.setAttribute('id', reactContainerId)
    this.appendChild(reactContainer)

    const container = document.getElementById(reactContainerId)
    const root = createRoot(container)

    root.render(<FooterWholesaler />)
  }
}

if (!customElements.get('footer-wholesaler')) {
  customElements.define('footer-wholesaler', FooterWholesalerElement)
}

const addCookiesAnalytics = () => {
  // Remove OneTrust logo
  if (document.getElementsByClassName('ot-pc-footer-logo')[0]) {
    document.getElementsByClassName('ot-pc-footer-logo')[0].remove()
  }

  // Remove GPC Banner When Cookie Tracking Off
  if (
    document
      .getElementsByClassName('ot-switch-nob')[0]
      .getAttribute('aria-checked') === 'true'
  ) {
    document.getElementsByClassName('ot-optout-signal')[0].hidden = true
  } else {
    document.getElementsByClassName('ot-optout-signal')[0].hidden = false
  }

  const oneTrustDesc = document.getElementById('ot-pc-desc')
  oneTrustDesc.innerHTML =
    'When you visit our website, we store cookies on your browser to collect information. We use cookies to share information with our advertising partners to assist in our marketing efforts. Specifically, we share your website activity with marketing providers to market products to you on other websites—cross-contextual behavioral advertising. We also use other cookies that are strictly necessary to ensure the proper functioning of our website and preserve your preferences. Those cookies are not used to market to you and cannot be turned off or limited. Further information is available in our <a class="u-textSizeMsrm1 Link" id=cookie-notice-link href=/privacy-statement>Cookie Notice</a>. <br> <br> You have a right to request we not share your data for cross-contextual behavioral advertising. Use the below toggle slider to confirm your preferences. The gray toggle color means you have opted out of data sharing and we won\'t sell or share your data with third-party agencies. You can change your preferences and confirm your choices anytime.'

  document
    .getElementById('close-pc-btn-handler')
    .setAttribute('data-analytics', 'onetrust-modal-close-btn')
  document
    .getElementsByClassName('save-preference-btn-handler')[0]
    .setAttribute('data-analytics', 'onetrust-confirm-choices-btn')
  document
    .getElementById('cookie-notice-link')
    .setAttribute('data-analytics', 'onetrust-cookie-notice-link')

  setTimeout(() => {
    // Unfocus Cookie Notice
    document.getElementById('cookie-notice-link').blur()

    const onetrustCookieTypes =
      document.getElementsByClassName('ot-subgrp-desc').length
    for (let i = 0; i < onetrustCookieTypes; i++) {
      if (
        document
          .getElementsByClassName('ot-subgrp-desc')
          [i].innerHTML.includes('targeted')
      ) {
        document.getElementsByClassName('ot-subgrp-desc')[i].innerHTML =
          'These cookies may be set through our site by our advertising partners. They may be used by those companies to build a profile of your interests and show you relevant ads on other sites. They do not store directly personal information but are based on uniquely identifying your browser and internet device. If you do not allow these cookies, you will experience less targeted advertising.'
      } else if (
        document
          .getElementsByClassName('ot-subgrp-desc')
          [i].innerHTML.includes('functional')
      ) {
        document.getElementsByClassName('ot-subgrp-desc')[i].innerHTML =
          'These cookies enable the website to provide enhanced functionality and personalization. They may be set by us or by third-party providers whose services we have added to our pages. If you do not allow these cookies then some or all of these services may not function properly.'
      }
    }
  })
}

window.addEventListener('load', () => {
  const onetrustButton = document.getElementById('ot-sdk-btn')

  if (onetrustButton) {
    onetrustButton.addEventListener('click', addCookiesAnalytics)
  }
})

window.geofeed = function (options) {
  // string two digit ISO country code
  const country = options.country.toString()
  // string two digit state code
  const state = options.state.toString()
  if (state == 'CA' && country == 'US') {
    const button = document.getElementById('ot-sdk-btn')

    if (!button) {
      const onetrustButton = document.createElement('button')
      onetrustButton.innerText = 'Do Not Sell or Share My Personal Data'
      onetrustButton.setAttribute('id', 'ot-sdk-btn')
      onetrustButton.setAttribute(
        'class',
        'ot-sdk-show-settings onetrust-footer Link u-textSizeMsrm1'
      )
      onetrustButton.setAttribute('data-analytics', 'onetrust-cta-button')
      // Add Span
      const footerSpan = document.createElement('span')
      footerSpan.setAttribute('class', 'Footer-legalLink')
      footerSpan.appendChild(onetrustButton)
      // Find Spot to Insert Button
      const privacySpan = document.getElementById('Privacy and Security')
      privacySpan?.after(footerSpan)
      document
        .getElementsByClassName('ot-sdk-show-settings onetrust-footer')?.[0]
        ?.addEventListener('click', addCookiesAnalytics)
    }
  }
}
// Call geo-location JSON service
window.addEventListener('DOMContentLoaded', () => {
  const existingScript = document.getElementById('geofeedScript')

  if (!existingScript) {
    const script = document.createElement('script')

    script.src =
      'https://geolocation.onetrust.com/cookieconsentpub/v1/geo/location/geofeed'
    script.async = true
    script.id = 'geofeedScript'

    document.head.appendChild(script)
  }
})
